/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _sortBy from 'lodash.sortby';
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import { Entities, Periods } from 'cio/utils/metrics/common';
import { DateRange } from '@customerio/fly-components/utils/fly-date-picker-utils';
import { Grouping } from 'cio/utils/metrics/resolution';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import MetricsService from 'cio/services/metrics';
import EnvironmentService from 'cio/services/environment';
import { tracked } from '@glimmer/tracking';
import { TrackedLinkMetric } from 'cio/utils/metrics/models/tracked-link-metric';
import SettingsService from 'cio/services/settings';

interface CampaignMetricsPageLinksCardArgs {
  campaign: CampaignModel;
  timeRange: DateRange;
  timePeriod: Periods;
  grouping: Grouping;

  onTrackCopyLink: () => unknown;
}

export default class CampaignMetricsPageLinksCard extends Component<CampaignMetricsPageLinksCardArgs> {
  @service metrics!: MetricsService;
  @service environment!: EnvironmentService;
  @service settings!: SettingsService;

  @tracked linkMetrics: TrackedLinkMetric | null = null;

  get showAllTimeTotals() {
    return this.args.timePeriod === Periods.ALL_TIME || this.args.timePeriod == null;
  }

  fetchMetrics = task({ keepLatest: true }, async () => {
    this.linkMetrics = await this.metrics.fetchTrackedLinkMetric(
      Entities.CAMPAIGN,
      this.args.campaign.id,
      this.args.timePeriod,
      this.args.timeRange,
      undefined,
      {
        campaignId: this.args.campaign.id,
        environmentId: this.environment.current.id,
      },
    );
  });

  get sortedLinkMetrics() {
    if (this.linkMetrics?.stats == null) {
      return [];
    }

    let sortBy = this.showAllTimeTotals ? 'totalClicked' : 'periodTotalClicked';
    return _sortBy(this.linkMetrics.stats, [sortBy]).reverse();
  }
}
